module.exports = __webpack_public_path__ + "static/media/steps_b.a1329e29.png";